const style = {
  wrap: {
    padding: '10px 25px 40px',
    background: '#ffffff7a',
    position: 'relative',
    minHeight: 'calc(100vh - 310px)',
  },
  wrapForm: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  view: {
    minHeight: '55vh',
    overflowX: 'auto',
    display: 'flex',
    margin: '10px 20px',
    paddingBottom: '15px',
  },
}

export default style



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasadors/AmbassadorsPipelineView/style.js